import {
  Collapse,
  InteractiveContainer,
  PlainButton,
} from "@jugl-web/ui-components";
import { cx } from "@jugl-web/utils";
import React, { PropsWithChildren, useState } from "react";
import { ReactComponent as ChevronIcon } from "./assets/chevron.svg";

type CXAutomationAccordionProps = PropsWithChildren<{
  number: number | string;
  title: React.ReactNode;
  initialIsOpen?: boolean;
  isOpen?: boolean;
  onOpenChange?: (next: boolean) => void;
  className?: string;
}>;

export const CXAutomationAccordion: React.FC<CXAutomationAccordionProps> = ({
  number: sectionNumber,
  title,
  children,
  initialIsOpen = true,
  isOpen: controlledIsOpen,
  onOpenChange,
  className,
}) => {
  const isControlled = controlledIsOpen !== undefined;
  const [internalIsOpen, setInternalIsOpen] = useState(initialIsOpen);
  const isOpen = isControlled ? controlledIsOpen : internalIsOpen;

  const handleToggle = () => {
    const next = !isOpen;
    if (isControlled) {
      onOpenChange?.(next);
    } else {
      setInternalIsOpen(next);
      onOpenChange?.(next);
    }
  };

  return (
    <div
      className={cx(
        "border-grey-300 rounded-2xl border border-solid bg-white",
        className
      )}
    >
      <InteractiveContainer
        onClick={handleToggle}
        className="flex w-full items-center justify-between gap-3 p-8"
      >
        <div className="flex min-w-0 items-center gap-2">
          <span className="font-secondary flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-full bg-[#2F80ED] text-[10px] font-semibold text-white">
            {sectionNumber}
          </span>
          <span className="font-secondary text-dark truncate text-lg font-medium">
            {title}
          </span>
        </div>
        <PlainButton
          className={cx(
            "flex h-6 w-6 shrink-0 items-center justify-center transition-transform",
            isOpen && "rotate-180"
          )}
        >
          <ChevronIcon />
        </PlainButton>
      </InteractiveContainer>
      <Collapse isOpen={isOpen} className="p-8 pt-0">
        {children}
      </Collapse>
    </div>
  );
};
